import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'
import {
  Loader,
  LoaderWrapper
} from '../../../components/page-loader/styled-components'

const RequirePermission = ({ allowed, isResolved, children }) => {
  if (!isResolved) {
    return (
      <LoaderWrapper>
        <Loader className="loader" />
      </LoaderWrapper>
    )
  }

  if (!allowed) {
    return (
      <Redirect to={{ pathname: '/', state: { data: 'permission denied' } }} />
    )
  }

  return <>{children}</>
}

RequirePermission.propTypes = {
  allowed: PropTypes.bool.isRequired,
  isResolved: PropTypes.bool.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
}

export default RequirePermission
